import React, { useState, useEffect } from 'react';
import { api } from '../api/client';

const TYPE_COLORS = {
  indica: { background: '#6b46c1', color: '#d6bcfa' },
  sativa: { background: '#2b6cb0', color: '#bee3f8' },
  hybrid: { background: '#c05621', color: '#fefcbf' },
};

export default function StrainAvailability() {
  const [strains, setStrains] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    api.get('/strains').then(data => {
      setStrains(data);
      setLoaded(true);
    }).catch(() => setLoaded(true));
  }, []);

  if (!loaded || strains.length === 0) return null;

  return (
    <div className="card" style={{ marginTop: 20 }}>
      <h3 style={{ marginBottom: 12 }}>Available Strains</h3>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: 10 }}>
        {strains.map(s => (
          <div key={s.id} style={{
            background: 'var(--bg-secondary)', border: '1px solid var(--border)',
            borderRadius: 'var(--radius-sm)', padding: 12
          }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
              <strong style={{ fontSize: 14 }}>{s.name}</strong>
              <span className="badge" style={TYPE_COLORS[s.type]}>{s.type}</span>
            </div>
            <div style={{ fontSize: 13, color: 'var(--success)' }}>
              In Stock
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
